export const sizes = ["8px", "16px", "32px", "64px", "128px"];